import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CalendarBar } from '../Calendar/CalendarBar';
import { VolleyCalendarContainer } from './styles';
import CupCalendarTabbar from '../../components/CupCalendarTabbar';
import PlayOffTable from './PlayOffTable';
import { getQuery } from '../../helpers';

class VolleyCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      betting: 0,
      currentPhase: null,
      currentSubPhase: null,
      subPhasesLength: null,
    };
  }

  componentDidMount() {
    this.resizeCallback();
    const { sportId, competitionId, seasonId } = window.matchcenterPage;
    const query = getQuery(document.location);
    if (query && query.fase && query.subfase) {
      this.props.actions.getVolleyTabbar(sportId, competitionId, seasonId, true, query.fase, query.subfase);
    } else {
      this.props.actions.getVolleyTabbar(sportId, competitionId, seasonId, true);
    }
    //this.props.actions.getVolleyTabbar(sportId, competitionId, '2014');
    window.addEventListener('resize', this.resizeCallback);
  }

  componentWillReceiveProps(nextProps) {
    const queryObj = getQuery(document.location);
    let { currentPhase, currentSubPhase, subPhasesLength } = this.state;
    if (queryObj && queryObj.fase) {
      if (queryObj.fase) {
        currentPhase = queryObj.fase;
        if (queryObj.subfase) {
          currentSubPhase = queryObj.subfase;
        }
      }
    } else {
      currentPhase = nextProps.cupTabbar.getIn(['lastPhase', 'label']);
      currentSubPhase = nextProps.cupTabbar.get('lastSubPhase');
    }
    if (nextProps.cupTabbar.getIn(['phases', currentPhase]) && nextProps.cupTabbar.getIn(['phases', currentPhase, 'subPhases'])) {
      subPhasesLength = Number(nextProps.cupTabbar.getIn(['phases', currentPhase, 'subPhases']).size);
    }
    this.setState({
      currentPhase, currentSubPhase, subPhasesLength,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= this.dynamicBreakPointWindow(process.env.REACT_APP_SITE),
    });
  };

  dynamicBreakPointWindow = (site) => {
    if (site === 'gazzetta') {
      return 1023;
    } else if (site === 'fcinter' || site === 'calcionapoli1926' || site === 'forzaroma') {
      return 980;
    } else if (site === 'corriere') {
      return 767;
    } else {
      return 1023;
    }
  };

  dateTimeHandler = (datetime) => {
    const month = this.props.dictionary.date.months[datetime.getMonth()];
    const day = datetime.getDate();
    return `${day} ${month}`;
  };

  corriereLink = () => {
    let returnedLink = '';
    if (process.env.REACT_APP_SITE === 'corriere') {
      returnedLink = '/sport';
    }
    return returnedLink;
  };

  render() {
    const {
      actions, dictionary, volleyCalendar,
      hasHighlights, cupTabbar, betMatch,
    } = this.props;
    const { competitionId } = window.matchcenterPage;
    const {
      isMobile, betting, currentPhase, currentSubPhase, subPhasesLength,
    } = this.state;
    return (
      <VolleyCalendarContainer>
        <CupCalendarTabbar
          currentPhase={currentPhase}
          currentSubPhase={currentSubPhase}
          phases={cupTabbar.get('phases')}
          dictionary={dictionary}
          actions={actions}
          isMobile={isMobile}
          isCup
          isSpecial={window.matchcenterPage.competitionId === 105}
          isInnerMenu={volleyCalendar.get('lastPhase') === 'playoffs' && (String(competitionId) === '54' || String(competitionId) === '53' || String(competitionId) === '35' || String(competitionId) === '34')
        }
        />
        {volleyCalendar && volleyCalendar.get('lastPhase') &&
        (volleyCalendar.get('lastPhase') !== 'groups') &&
          <div>
            {volleyCalendar && volleyCalendar.get('games') &&
              <CalendarBar
                dictionary={dictionary}
                actions={actions}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                competitionId={competitionId}
                noTitleOnFinal={cupTabbar.get('lastSubPhase')}
              />
            }
            {volleyCalendar && volleyCalendar.get('games') && volleyCalendar.get('games').map((game, i) => (
              <React.Fragment key={i}>
                {game && game.get('firstLeg') && game.get('firstLeg').map((c, index) => (
                  <PlayOffTable
                    matchDate={c.get('date')}
                    matches={c.get('matches')}
                    dictionary={dictionary}
                    hasHighlights={hasHighlights}
                    isMobile={isMobile}
                    actions={actions}
                    key={index}
                  />
                ))
                }
              </React.Fragment>
            ))
            }
            {volleyCalendar && volleyCalendar.get('games') && volleyCalendar.get('games').map((game, i) => (
              <React.Fragment key={i}>
                {game && game.get('firstLeg') && game.get('secondLeg').map((c, index) => (
                  <PlayOffTable
                    matchDate={c.get('date')}
                    matches={c.get('matches')}
                    dictionary={dictionary}
                    hasHighlights={hasHighlights}
                    isMobile={isMobile}
                    actions={actions}
                    key={index}
                    betMatch={betMatch}
                    betType={betting}
                  />
                ))
                }
              </React.Fragment>
            ))
            }
          </div>
        }
        {volleyCalendar && volleyCalendar.get('lastPhase') &&
        (volleyCalendar.get('lastPhase') === 'groups') &&
          <div>
            {subPhasesLength && subPhasesLength > 1 &&
              <CalendarBar
                dictionary={dictionary}
                actions={actions}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                currentSubPhase={cupTabbar.get('lastSubPhase')}
                isCup
              />
            }
            {volleyCalendar && volleyCalendar.get('games') && volleyCalendar.get('games').map((c, index) => (
              <PlayOffTable
                groupsPhase
                matchDate={c.get('date')}
                matches={c.getIn(['matches', 0])}
                dictionary={dictionary}
                hasHighlights={hasHighlights}
                isMobile={isMobile}
                actions={actions}
                key={index}
                isGroups
              />
            ))
            }
          </div>
        }
      </VolleyCalendarContainer>
    );
  }
}

VolleyCalendar.propTypes = {
  dictionary: PropTypes.any,
  actions: PropTypes.any,
  volleyCalendar: PropTypes.any,
  hasHighlights: PropTypes.bool,
  cupTabbar: PropTypes.any,
  betMatch: PropTypes.any,
};

export default VolleyCalendar;



// WEBPACK FOOTER //
// ./src/containers/VolleyCalendar/index.js